import { Trans } from "react-i18next";

interface ErrorPageProps {
    error: Error;
    resetErrorBoundary: () => void;
}
export const ErrorPage = (props: ErrorPageProps)=> {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.
  
    return (
        <div className ="error-container">
        <div className="error-message">
          <h1><Trans>general.generalErrorTitle</Trans></h1>
          <p> <Trans>general.generalErrorMessage</Trans></p>
          <p className="error-details"><small><strong><Trans>general.techincalErrorMessage</Trans></strong> {props.error.message}</small></p>
        </div>
       
      </div>
    );
  }